/**
 * Tenký horní pruh — telefon, email, jazyk, "Rezervovat" CTA.
 * Deep spruce band, inline SVG ikony (žádné emoji).
 */

function Icon({ d }: { d: string }) {
  return (
    <svg viewBox="0 0 24 24" className="w-3.5 h-3.5" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
      <path d={d} />
    </svg>
  )
}

export function TopBar() {
  return (
    <div className="hidden md:block bg-steel-800 text-white/80 text-[12px]">
      <div className="container-x flex items-center justify-between py-2">
        <div className="flex items-center gap-5">
          <a href="tel:+420775140705" className="flex items-center gap-1.5 hover:text-white transition-colors">
            <Icon d="M22 16.9v3a2 2 0 0 1-2.2 2 19.8 19.8 0 0 1-8.6-3 19.5 19.5 0 0 1-6-6 19.8 19.8 0 0 1-3-8.7A2 2 0 0 1 4.1 2h3a2 2 0 0 1 2 1.7c.1 1 .4 2 .7 2.9a2 2 0 0 1-.5 2.1L8.1 10a16 16 0 0 0 6 6l1.3-1.3a2 2 0 0 1 2.1-.4c1 .3 2 .5 3 .6a2 2 0 0 1 1.6 2z" />
            <span>+420 775 140 705</span>
          </a>
          <a href="mailto:rezervace.sobacov@gmail.com" className="flex items-center gap-1.5 hover:text-white transition-colors">
            <Icon d="M4 4h16a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2zM22 6l-10 7L2 6" />
            <span>rezervace.sobacov@gmail.com</span>
          </a>
          <span className="flex items-center gap-1.5 text-white/50">
            <Icon d="M20 10c0 6-8 12-8 12s-8-6-8-12a8 8 0 0 1 16 0zM12 13a3 3 0 1 0 0-6 3 3 0 0 0 0 6z" />
            <span>Sobáčov 111, 783 21 Mladeč</span>
          </span>
        </div>
        <div className="flex items-center gap-4">
          <a
            href="#rezervace"
            className="bg-brand-500 hover:bg-brand-600 text-white px-3.5 py-1.5 font-semibold text-[12px] rounded-lg transition-colors"
          >
            Rezervovat
          </a>
        </div>
      </div>
    </div>
  )
}
